<!--components\Aceites\AsiFunciona.vue-->
<template>
    <section class="w-full pb-10 md:pb-[2rem] pt-6 md:pt-[2rem]">
        <div class="w-full max-w-[76rem] mx-auto px-4 md:px-6">
            <!-- Título de la sección -->
            <div class="text-center pb-6">
                <h3 class="text-1xl md:text-2xl font-semibold text-gray-900 tracking-wide">
                    Así es como funciona
                </h3>
            </div>

            <!-- Versión Desktop: Grid de 3 columnas -->
            <div class="hidden md:flex justify-center">
                <div class="grid grid-cols-1 md:grid-cols-3 gap-8 w-4/5">
                    <CardTipo1 v-for="(item, index) in funcionamientoData" :key="index" 
                    :clase_contenedor_padre="item.clase_contenedor_padre" :imagen_clase="item.imagen_clase"
                    :imagen="item.imagen" :paso="item.paso" :titulo="item.titulo" :texto="item.texto" />
                </div>
            </div>

            <!-- Versión Mobile: Carrusel con slots -->
            <div class="block md:hidden px-4">
                <Carrusel
                    :data="funcionamientoData"
                    :itemsPorPagina="itemsPorPagina"
                    :ClaseSlide="ClaseSlide"
                    :autoplay="true" 
                    :autoplayInterval="4000" 
                    :bucle="true"
                    :habilitarBotonesNav="false"
                    :motrarPuntos="false"

                    customBotonesNavClass="p-2 bg-white hover:bg-gray-100 text-gray-800 border border-gray-300 shadow-md"
                    customIconClass="text-current w-5 h-5" 
                    customPrevPosition="left-0 -translate-x-3"
                    customNextPosition="right-0 translate-x-3">
                    
                    <!-- Slot para renderizar CardTipo1 -->
                    <template #contenido="{ items }">
                        <CardTipo1 v-for="(item, index) in items" :key="index" 
                        :clase_contenedor_padre="item.clase_contenedor_padre" 
                        :imagen_clase="item.imagen_clase"
                        :imagen="item.imagen" 
                        :paso="item.paso" 
                        :titulo="item.titulo" 
                        :texto="item.texto" />
                    </template>
                </Carrusel>
            </div>
        </div>
    </section>
</template>

<script setup>
import { ref } from 'vue'
import CardTipo1 from '~/components/Cards/CardTipo1.vue'
import Carrusel from '~/components/Carruseles/Carrusel.vue'

const ClaseSlide = ref('flex flex-col gap-5 h-[32rem] p-2')
const itemsPorPagina = ref(1)

// Data de los pasos del funcionamiento
const funcionamientoData = ref([
    {
        clase_contenedor_padre: 'py-3 md:py-7 px-3 md:px-7 h-full md:h-auto',
        imagen_clase: 'flex h-full w-auto md:h-auto md:w-[80%]',
        imagen: '/img/aceites/mapa.png',
        paso: 'Paso 1',
        titulo: 'Agrega los datos de tu auto y selecciona a qué local quieres ir',
        texto: 'Así, cuando nos visites, tendremos el stock disponible e inmediato de las piezas necesarias para realizar tu servicio y asegurarte la mayor rapidez.'
    },
    {
        clase_contenedor_padre: 'py-3 md:py-7 px-3 md:px-7 h-full md:h-auto',
        imagen_clase: 'flex h-full w-auto md:h-auto md:w-[80%]',
        imagen: '/img/aceites/calendario.png',
        paso: 'Paso 2',
        titulo: 'Escoge el día y la hora de tu visita',
        texto: 'Nuestro equipo se contactará contigo para coordinar y reservar tu visita. Además, resolverá tus dudas, en caso de que lo necesites.'
    },
    {
        clase_contenedor_padre: 'py-3 md:py-7 px-3 md:px-7 h-full md:h-auto',
        imagen_clase: 'flex h-full w-auto md:h-auto md:w-[80%]',
        imagen: '/img/aceites/market.png',
        paso: 'Paso 3',
        titulo: 'Confía en nuestros expertos',
        texto: 'Tu auto estará siempre en manos de un experto, quien te brindará una atención personalizada y cercana. Recibirás una asesoría clara y detallada sobre el diagnóstico y la reparación recomendada.'
    }
])
</script>